<template>
  <div
    id="app"
    :class="{SGD:this.$institut === 'SGD', HFB: this.$institut === 'HFB', TEC: this.$institut === 'TEC', IOC: this.$institut === 'IOC', APP: this.$institut === 'APP', }"
  >
    <router-view></router-view>
  </div>
</template>

<script>
// import LoginIndex from './components/login/Index.vue'

export default {
  name: "app",
  created() {
    console.log("create app");
  }
};
</script>

<style lang="less">
@main-bg-color: #fff;

/* @main-font-family: Open Sans; */

@main-font-size: 16px;

@FontPathOpenSans: "/fonts";
/* sgd fonts */
/*
  @import '../node_modules/npm-font-open-sans/open-sans';
  */
@import "../node_modules/npm-font-open-sans/open-sans.css";

/* hfb fonts Hier bei der SGD ?? REMOVE ME ??? */
@import "../node_modules/typeface-fira-sans/index.css";

/* import login-page styles */
@import "../node_modules/wl-vue-component-login/dist/wl-vue-component-login.css";

@main-font-family: "Open Sans";

//@import url(http://fonts.googleapis.com/css?family=Roboto+Slab|Open+Sans|Open+Sans+Bold:400italic,700italic,400,700);

body {
  background: @main-bg-color;
  margin: 0;
  padding: 0;
}

#app {
  font-family: @main-font-family;
  font-size: @main-font-size;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
